module.exports = __webpack_public_path__ + "static/media/InstagramIcon.adee9779.svg";